import { uniqueId } from 'lodash';
import type { Resolvers } from '../../../../../generated';

export const resolvers: Resolvers = {
  MetadataSortBy: {
    id: (sortBy) => sortBy.id || uniqueId('sortBy-'),
  },
};
